export const TEST_ID = 'tabPanelParts';
